import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { libservice } from 'src/app/lib/lib.service';
import { Observable } from 'rxjs';
import { AutofocuseServiceDirective } from 'src/app/core/navigation/navigaterouter/autofocusE.Service';
import { NavigationRootService } from 'src/app/core/navigation/navigaterouter/Navigation.Service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { InputChangeDirective } from 'src/app/lib/inputchange.directive';
import { FilterOptionsPipe } from '../../filter.pipe';
import { MatInputModule } from '@angular/material/input';
import { OptionsScrollDirective } from '../../input-table/options-scroll.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import moment from 'moment';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY' // Input format for parsing
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
@Component({
  selector: 'app-todate',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatFormFieldModule, MatAutocompleteModule, ReactiveFormsModule, MatDatepickerModule, MatInputModule, MatButtonModule, MatIconModule, MatDividerModule],
  styleUrl: './../styles/todate.scss',
  template: `<div class="flex items-center" mat-dialog-title>
      <h2 class="headline m-0 flex-auto"></h2>

      <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
        <mat-icon svgIcon="mat:close"></mat-icon>
      </button>
    </div>
    <mat-divider class="text-border"></mat-divider>
    <mat-dialog-content>
      <mat-form-field class="w-full" subscriptSizing="dynamic" [formGroup]="dataform">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="picker" cdkFocusInitial formControlName="fdt" (keydown)="enterevent($event)" (focus)="selectText($event)" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="w-full mt-5" subscriptSizing="dynamic" [formGroup]="dataform">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="picker1" formControlName="tdt" (keydown)="enterevent($event)" (focus)="selectText($event)" />
        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close="no" type="button">Cancel</button>
      <button color="primary save-button-class" mat-flat-button type="submit" (click)="save()">Submit</button>
    </mat-dialog-actions>`,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }
  ],
  encapsulation: ViewEncapsulation.None
})
export class todateComponent {
  constructor(
    private navigation: NavigationRootService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<todateComponent>,
    private fb: FormBuilder
  ) {
    this.dataform = this.fb.group({
      fdt: [''],
      tdt: ['']
    });
    this.dataform.patchValue(data);
  }
  dataform!: FormGroup;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.dialogRef.close('no');
    }
  }
  enterevent(event: any) {
    this.navigation.focusNextInput(event);
  }
  changeDate() {}
  selectText(event: any) {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
  }
  save() {
    if (!(this.dataform.get('fdt')?.value != null && this.dataform.get('fdt')?.value != '' && this.dataform.get('tdt')?.value != null && this.dataform.get('tdt')?.value != '')) {
      return;
    }
    this.dataform.controls['fdt'].setValue(moment(this.dataform.get('fdt')?.value).format('YYYY-MM-DD'));
    this.dataform.controls['tdt'].setValue(moment(this.dataform.get('tdt')?.value).format('YYYY-MM-DD'));
    let postdata: any = {
      ...this.dataform.value,
      rs: 'yes'
    };
    this.dialogRef.close(postdata);
  }
}
